// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsCompose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.195 3.138a.471.471 0 0 1 .666 0l2 2.002a.472.472 0 0 1 0 .667l-1.688 1.69-2.668-2.669zM6.489 20.188a.66.66 0 0 1-.314.173L3.573 21c-.265.004-.572-.3-.573-.568v-.005l.65-2.596a.658.658 0 0 1 .17-.31L15.527 5.807l2.668 2.67zM20.5 19a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsCompose;
